module.exports = __webpack_public_path__ + "static/media/option-3.3045bb9d.ogg";